<script setup>
import FormElementMixins from '@/mixins/FormElementMixins'
</script>
<template lang="">
    <div>
        <div class="mb-3">
            <label
              :for="`field${element.type}${index}`"
              class="form-label"
              v-if="fieldTitle">
              {{ fieldTitle }}
            </label>
            <input
            @keydown="onKeydown"
            @input="onInput"
            pattern="\d{4,4}"
            maxlength="4"
            :data-section="element.section"
            v-model="fieldValue"
            type="text" inputmode="numeric"
            class="form-control"
            :id="`field${element.type}${index}`"
            :placeholder="element.placeholder"
            :required="element.required">
        </div>
    </div>
</template>
<script>
export default {
  name: 'FormElementPin',
  mixins: [FormElementMixins]
}

function onInput(event) {
  const inputElement = event.target;

  const hasNoDigits = /\D/.test(inputElement.value)

  if (hasNoDigits) {
    inputElement.setCustomValidity('Indtast venligst kun cifre.');
  } else if (inputElement.value.length > 4) {
    inputElement.setCustomValidity('Maksimalt 4 tegn er tilladt her');
  } else {
    inputElement.setCustomValidity('');
  }
}

function onKeydown(event) {
  const inputElement = event.target;
  const inputValue = inputElement.value;

  // Allow modifier keys
  if (event.metaKey || event.ctrlKey) return true;
  const navigationKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Home',
    'End',
  ];
  if (navigationKeys.includes(event.key)) return true;

  // Disallow non digits and more than 4 chars
  const isDigit = /^\d$/.test(event.key);
  if (inputValue.length >= 4 || !isDigit) event.preventDefault();
}
</script>
<style lang="">
</style>
